import styled from "styled-components"
import { Row } from "reactstrap"

const OptionsRowStyle = styled(Row)`
    max-width: 750px;
    margin: auto;
`

export default OptionsRowStyle